import { FC } from "react";
import "./dailyProductMetrics.css";
import { DonutChartLined } from "@tag/tag-icons";
import { useForecastContext } from "../../../../context/forecastContext";
import { useTheme } from "../../../../context/themeContext";
import SkeletonLoader from "../../../SkeletonLoader";
import ErrorMessage from "../../../errorMessage/errorMessage";
import dayjs from "dayjs";
import { findForecastForDay } from "../../../../utilities/forecastHelpers";
import { useForecastQuery } from "../../../../services/forecastService";

type DailyProductMetricsProps = {};

const DailyProductMetrics: FC<DailyProductMetricsProps> = () => {
  const { theme } = useTheme();
  const { forecastState } = useForecastContext();

  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Forecast" fontSize="13px" />;
  }

  const forecast = findForecastForDay(
    dayjs(forecastState.selectedDate).format("YYYY-MM-DD"),
    forecasts ?? []
  );

  // if (!forecast) {
  //   return <SkeletonLoader />;
  // }

  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div className="daily-product-metrics-container">
      <div className="daily-product-metrics-header">
        <div className="daily-product-metrics-header-title">
          <span>
            <DonutChartLined accent="teal" /> {"Product Usage Metrics"}
          </span>
        </div>
      </div>
      <div className="daily-product-metrics-content-container"></div>
    </div>
  );
};

export default DailyProductMetrics;
